// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2PKx1","amount":"Amount_amount__2foBC","tip":"Amount_tip__glTH8","tipHeader":"Amount_tipHeader__4ihDr","tipsWrap":"Amount_tipsWrap__2pCHQ"};